<template>
  <div class="card shadow mb-4">
    <!-- Card Header -->
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 class="m-0 font-weight-bold">{{ $t('Savings') }}</h6>
      <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="$t('home_tooltip_savings')"></i>
    </div>
    <!-- End of Card Header -->
    <!-- Card Body -->
    <div class="card-body">
      <div class="row text-center">
        <div class="col-4 col-sm-4 col-md-4 border-right-1">
          <LoadingSpinner v-if="loading"></LoadingSpinner>
          <span v-else class="h4 mb-0 font-weight-bold text-green">{{ House_Savings }}</span>
          <p>kWh</p>
        </div>
        <div class="col-4 col-sm-4 col-md-4 border-right-1">
          <LoadingSpinner v-if="loading"></LoadingSpinner>
          <span v-else class="h4 mb-0 font-weight-bold text-green">{{ House_Savings_Euro }}</span>
          <p>€</p>
        </div>
        <div class="col-4 col-sm-4 col-md-4">
          <LoadingSpinner v-if="loading"></LoadingSpinner>
          <span v-else class="h4 mb-0 font-weight-bold text-green">{{ House_Savings_CO2 }}</span>
          <p>gCO2</p>
        </div>
      </div>
    </div>
    <!-- End of Card Body -->
  </div>
</template>

<script>
import friendlyFloatingPoint from '../helpers/friendlyFloatingPoint.js'
import LoadingSpinner from './LoadingSpinner.vue'

export default {
  name: 'Savings',
  components: {
    LoadingSpinner,
  },
  computed: {
    data: function(){
      return this.$store.getters.data_savings
    },
    House_Savings_CO2: function(){
      if (this.data.Savings_CO2 != null) return friendlyFloatingPoint(Math.max(0,this.data.Savings_CO2))
      else return '-'
    },
    House_Savings_Euro: function(){
      if (this.data.Savings_Euro != null) return friendlyFloatingPoint(Math.max(0,this.data.Savings_Euro))
      else return '-'
    },
    House_Savings: function(){
      if (this.data.Savings != null) return friendlyFloatingPoint(Math.max(0,this.data.Savings))
      else return '-'
    },
    loading: function(){
      return this.$store.getters.data_loading
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-header-custom {
  border-radius: .25rem .25rem 0 0;
  padding: .75rem 1.25rem;
  background-color: #f8f9fc;
  margin-bottom: 0;
  padding: .75rem 1.25rem;
}
.card-header-custom + .card-group > .card {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.card-header:first-child{
  border-radius: calc(.35rem - 1px) calc(.35rem - 1px) 0 0;
}
.panel-number{
  font-weight:700;
}
</style>